import React from 'react';
import { Heart, Instagram, Facebook, Youtube } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <img 
              src="https://customer-assets.emergentagent.com/job_shashank-weddings/artifacts/6gdgpp41_Primary%20logo%20.png" 
              alt="Ever After by Shashank"
              className="footer-logo-img"
            />
            <p className="footer-tagline">A Cinematic Wedding Story Studio</p>
            <p className="footer-description">
              Capturing your love story with artistry and authenticity.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h3>Quick Links</h3>
              <ul>
                <li><button onClick={() => scrollToSection('home')}>Home</button></li>
                <li><button onClick={() => scrollToSection('about')}>About</button></li>
                <li><button onClick={() => scrollToSection('services')}>Services</button></li>
                <li><button onClick={() => scrollToSection('portfolio')}>Portfolio</button></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Services</h3>
              <ul>
                <li><button>Wedding Photography</button></li>
                <li><button>Cinematic Films</button></li>
                <li><button>Pre-Wedding Shoots</button></li>
                <li><button>Destination Weddings</button></li>
              </ul>
            </div>

            <div className="footer-column">
              <h3>Connect</h3>
              <ul>
                <li><a href="tel:+919876543210">+91 98765 43210</a></li>
                <li><a href="mailto:hello@everafterbyshashank.com">hello@everafterbyshashank.com</a></li>
              </ul>
              <div className="footer-social">
                <a href="https://instagram.com/everafterbyshashank" target="_blank" rel="noopener noreferrer">
                  <Instagram size={18} />
                </a>
                <a href="https://facebook.com/everafterbyshashank" target="_blank" rel="noopener noreferrer">
                  <Facebook size={18} />
                </a>
                <a href="https://youtube.com/everafterbyshashank" target="_blank" rel="noopener noreferrer">
                  <Youtube size={18} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} Ever After by Shashank. Made with <Heart size={14} fill="var(--gold)" color="var(--gold)" /> for couples in love.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
